export var ServiceErrorType;

(function (ServiceErrorType) {
  ServiceErrorType["ServiceUnknown"] = "ERROR_SERVICE_UNKNOWN";
  ServiceErrorType["MethodUnknown"] = "ERROR_SERVICE_METHOD_UNKNOWN";
})(ServiceErrorType || (ServiceErrorType = {}));
//# sourceMappingURL=ServiceErrorType.js.map